'use client';

import React, { useEffect, useState } from 'react';
import type { StripBannerItemRes } from '../api/banner/dto/response/banner.res.dto';
import useBandBanner from '../utils/hook/useBandBanner';
import AnimatedBannerWrapper from './AnimatedBannerWrapper';
import ApiStripBanner from './ApiStripBanner';

const BandBanner = () => {
  const { canShowApiStripBanner, apiStripBannerData } = useBandBanner();

  /**
   * 마지막으로 노출한 배너 — 접히는 동안 그릴 내용.
   * 노출 조건이 꺼지는 순간 내용까지 지우면 높이가 줄어드는 사이 빈 상자만 남아
   * 색이 빠지며 사라진다(빠르게 스크롤할 때 흰 띠로 보임). 내용은 붙잡아 두고 높이만 줄인다.
   * 한 번도 노출되지 않은 화면에서는 null이라 배너 이미지를 받지 않는다.
   */
  const [lastShownBanner, setLastShownBanner] =
    useState<StripBannerItemRes | null>(null);

  useEffect(() => {
    if (canShowApiStripBanner && apiStripBannerData) {
      setLastShownBanner(apiStripBannerData);
    }
  }, [canShowApiStripBanner, apiStripBannerData]);

  const bannerToRender = canShowApiStripBanner
    ? apiStripBannerData
    : lastShownBanner;

  return (
    <AnimatedBannerWrapper isVisible={canShowApiStripBanner}>
      {bannerToRender && <ApiStripBanner data={bannerToRender} />}
    </AnimatedBannerWrapper>
  );
};

export default BandBanner;
